export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
export function isNullAddress(address) {
    return address === undefined || address === NULL_ADDRESS;
}
export var WalletStatus;
(function (WalletStatus) {
    WalletStatus["Connected"] = "connected";
    WalletStatus["Reconnecting"] = "reconnecting";
    WalletStatus["Connecting"] = "connecting";
    WalletStatus["Disconnected"] = "disconnected";
})(WalletStatus || (WalletStatus = {}));
export var BlockchainTransactionType;
(function (BlockchainTransactionType) {
    BlockchainTransactionType["CreateSpace"] = "createSpace";
    BlockchainTransactionType["CreateChannel"] = "createChannel";
    BlockchainTransactionType["DeleteChannel"] = "deleteChannel";
    BlockchainTransactionType["EditChannel"] = "editChannel";
    BlockchainTransactionType["UpdateRole"] = "updateRole";
    BlockchainTransactionType["SetChannelPermissionOverrides"] = "setChannelPermissionOverrides";
    BlockchainTransactionType["ClearChannelPermissionOverrides"] = "clearChannelPermissionOverrides";
    BlockchainTransactionType["CreateRole"] = "createRole";
    BlockchainTransactionType["DeleteRole"] = "deleteRole";
    BlockchainTransactionType["UpdateSpaceInfo"] = "updateSpaceInfo";
    BlockchainTransactionType["LinkWallet"] = "linkWallet";
    BlockchainTransactionType["UnlinkWallet"] = "unlinkWallet";
    BlockchainTransactionType["BanUser"] = "banUser";
    BlockchainTransactionType["UnbanUser"] = "unbanUser";
    BlockchainTransactionType["JoinSpace"] = "joinSpace";
    // not a single tx, but a series of txs exectued in a single user operation
    BlockchainTransactionType["EditSpaceMembership"] = "editSpaceMembership";
    BlockchainTransactionType["PrepayMembership"] = "prepayMembership";
    BlockchainTransactionType["TransferNft"] = "transferNft";
    BlockchainTransactionType["WithdrawTreasury"] = "withdrawTreasury";
    BlockchainTransactionType["TransferBaseEth"] = "transferBaseEth";
    BlockchainTransactionType["RefreshMetadata"] = "refreshMetadata";
    BlockchainTransactionType["Tip"] = "tip";
    BlockchainTransactionType["CheckIn"] = "checkIn";
    BlockchainTransactionType["Trade"] = "trade";
    BlockchainTransactionType["Review"] = "review";
})(BlockchainTransactionType || (BlockchainTransactionType = {}));
//# sourceMappingURL=web3-types.js.map